var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_-outline-expand",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#013289"
    },
    points: "4,20 11,20 16,14 18,20 21,24 19,29 17,32 14,32 14,34 17,38 25,40 19,54 16,55 16,44 11,39  7,26 3,26 3,22 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#013289"
    },
    points: "31,23 29,26 26,28 30,30 25,33 27,36 32,37 32,41 34,44 36,44 38,38 38,34 41,34 43,37  46,34 47,36 47,39 55,41 52,37 51,34 54,31 54,26 61,24 61,21 51,16 48,16 37,22 34,20 31,20 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#013289"
    },
    points: "50,50 50,47 53,45 57,45 59,48 59,51 54,49 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#013289"
    },
    points: "23,10 29,10 29,15 25,21 22,16 20,15 20,10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe"
    },
    d: "M48.036,29.264c-0.021-0.075-2.119-7.523-7.617-11.45c-6.571-4.693-16.127-2.852-16.223-2.833 l-0.393-1.961c0.425-0.085,10.508-2.026,17.777,3.167c6.088,4.348,8.293,12.218,8.384,12.551L48.036,29.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe"
    },
    d: "M48.294,29.709c-0.048-0.048-4.911-4.766-14.394-5.714c-9.594-0.962-16.439,1.896-16.507,1.924 l-0.787-1.838c0.296-0.127,7.353-3.089,17.494-2.076c10.237,1.024,15.393,6.074,15.607,6.288L48.294,29.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe"
    },
    d: "M56.782,47.624l-1.564-1.247c0.043-0.055,4.342-5.536,2.833-10.061 c-1.78-5.34-9.102-6.315-9.175-6.324l-0.121-0.022c-0.053-0.013-5.636-1.321-14.404,1.967c-7.595,2.848-12.455,10.516-12.503,10.593 l-1.696-1.06c0.211-0.338,5.274-8.323,13.497-11.407c9.005-3.375,14.834-2.208,15.533-2.048c0.82,0.113,8.662,1.354,10.767,7.668 C61.802,41.244,56.987,47.366,56.782,47.624z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpread);
export default __webpack_public_path__ + "static/media/spread.7391ce4abc072f29beb0096c0b6d63ce.svg";
export { ForwardRef as ReactComponent };